import { NextPage } from "next";
import { useIntl } from "react-intl";
import { PageProps } from "@/pages/_app";
import Layout from "@/components/layout/Layout";
import { SEO } from "@/interfaces/seo";
import { SEOWithoutTemplate } from "@/interfaces/seoWithoutTemplate";
import HeroBlock, {
  HeroBlockProps,
} from "@/components/common/heroBlock/HeroBlock";
import { Section } from "@/components/common/section/Section";
import { DescriptiveBlockWithOptionalValuesList } from "@/components/common/descriptiveBlockWithOptionalValuesList/DescriptiveBlockWithOptionalValuesList";
import { DescriptiveBlockWithOptionalValuesProps } from "@/components/common/descriptiveBlockWithOptionalValuesList/descriptiveBlockWithOptionalValues/DescriptiveBlockWithOptionalValues";
import { Banner, BannerProps } from "@/components/common/banner/Banner";
import styles from "./Commitments.module.scss";

export type CommitmentsPageContent = {
  heroBlock: HeroBlockProps;
  banner: BannerProps;
  engagementBlockList: DescriptiveBlockWithOptionalValuesProps[];
  seo: SEO;
  seoWithoutTemplate: SEOWithoutTemplate;
};

type CommitmentsPageProps = PageProps &
  CommitmentsPageContent & {
    defaultCanonicalRoute: string;
  };

export const Commitments: NextPage<CommitmentsPageProps> = ({
  layout,
  heroBlock,
  banner,
  engagementBlockList,
  seo,
  seoWithoutTemplate,
  defaultCanonicalRoute,
}: CommitmentsPageProps) => {
  const intl = useIntl();

  return (
    <Layout
      layout={layout}
      defaultCanonicalRoute={defaultCanonicalRoute}
      pageMeta={seo}
      title={seoWithoutTemplate.title}
      description={seoWithoutTemplate.description}
      breadcrumbs={[
        { title: intl.formatMessage({ id: "home" }), url: "/" },
        {
          title: intl.formatMessage({ id: `commitmentsBreadcrumb` }),
          url: defaultCanonicalRoute,
        },
      ]}
    >
      <HeroBlock {...heroBlock} hideSearchBlock={true} />
      <Section containerStyle={styles.container} sectionStyle={styles.section}>
        <Banner {...banner} />

        <DescriptiveBlockWithOptionalValuesList
          descriptiveBlocksWithOptionalValues={engagementBlockList}
        />
      </Section>
    </Layout>
  );
};
